import { isProductCategoryEditable } from '@/components/FestivalShop/helpers'
import type { ExtrasOrdersQuery } from '@/gql/myomr'

export type ExtrasOrderNode = ExtrasOrdersQuery['extrasOrders']['nodes'][number]
export type ExtrasOrderRawItem = ExtrasOrderNode['extras'][number]

export type ExtrasOrderItem = Omit<ExtrasOrderRawItem, 'count' | 'price' | 'deliveryFee'> & {
  canRemove: boolean
  count: number
  deliveryFee?: number | null
  displayId: string
  editable: boolean
  isHistoricalPriceSnapshot: boolean
  isSplitByPriceSnapshot: boolean
  price: number
  sourceItemId: string
  snapshotId?: string
}

export const getOrderDisplayItems = (order: ExtrasOrderNode): ExtrasOrderItem[] => {
  return order.extras.flatMap<ExtrasOrderItem>((item): ExtrasOrderItem[] => {
    const categoryEditable = isProductCategoryEditable(item.product.productCategory)

    if (!item.priceSnapshots.length) {
      return [
        {
          ...item,
          canRemove: categoryEditable,
          displayId: item.id,
          editable: categoryEditable,
          isHistoricalPriceSnapshot: false,
          isSplitByPriceSnapshot: false,
          sourceItemId: item.id,
        },
      ]
    }

    if (item.priceSnapshots.length === 1) {
      const snapshot = item.priceSnapshots[0]

      return [
        {
          ...item,
          canRemove: categoryEditable && snapshot.editable,
          count: snapshot.count,
          deliveryFee: snapshot.deliveryFee,
          displayId: `${item.id}:${snapshot.id}`,
          editable: categoryEditable && snapshot.editable,
          isHistoricalPriceSnapshot: !snapshot.editable,
          isSplitByPriceSnapshot: false,
          price: snapshot.price,
          snapshotId: snapshot.id,
          sourceItemId: item.id,
        },
      ]
    }

    return item.priceSnapshots.map<ExtrasOrderItem>((snapshot) => ({
      ...item,
      canRemove: categoryEditable && snapshot.editable,
      count: snapshot.count,
      deliveryFee: snapshot.deliveryFee,
      displayId: `${item.id}:${snapshot.id}`,
      editable: categoryEditable && snapshot.editable,
      isHistoricalPriceSnapshot: !snapshot.editable,
      isSplitByPriceSnapshot: true,
      price: snapshot.price,
      snapshotId: snapshot.id,
      sourceItemId: item.id,
    }))
  })
}
